import { createI18n } from 'vue-i18n';
import { getLocalization } from '../shared/localizationService';

const loadMessages = () => {
  const regExPattern = /[a-z]{2}_[A-Z]{2}/;
  const localeFiles = Object.entries(
    import.meta.glob('./localization/*.json', { eager: true })
  );
  const messages: { [index: string]: any } = {};

  for (const [key, value] of localeFiles) {
    const matched = key.match(regExPattern);

    if (matched && matched.length) {
      const locale = matched[0];
      messages[locale] = JSON.parse(JSON.stringify(value)).default;
    }
  }

  return messages;
};

const localization = getLocalization();

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localization.value.Locale,
  fallbackLocale: 'en_GB',
  messages: loadMessages()
});

export default i18n;
